module.exports = __webpack_public_path__ + "static/media/button-app-store.3be95960.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/button-app-store.png
// module id = 1004
// module chunks = 0